let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iWTwf")).then(() => parcelRequire('byCzz'));